import { React } from "react";
import classes from './Reachability.module.scss';

//MUI Imports

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

function Reachability({ connectionIssue }) {

    if(connectionIssue){
        return (
            <Stack sx={{ position: 'fixed', width: '100%', textAlign: 'left', zIndex:'5' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle><h2>Connection Issues</h2></AlertTitle>
                    <p><strong>WARNING!</strong> If you can see this message,  it means your content will not be saved. Attempting to reconnect<span className={classes.Reachability__loader}></span></p>
                </Alert>
            </Stack>
            // <div className={classes.Reachability}>
            //     
            //     
            //     
            // </div>
        );
    }else{
        return ("")
    }
}
export default Reachability